var _polyline, _line, _line2, _line3, _polyline2, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoChallenge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#895aef",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-swords text-primary size-20 mx-auto mb-4 opacity-90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    x2: 19,
    y1: 19,
    y2: 13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 20,
    y1: 16,
    y2: 20
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    x2: 21,
    y1: 21,
    y2: 19
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    x2: 9,
    y1: 14,
    y2: 18
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 4,
    y1: 17,
    y2: 20
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 5,
    y1: 19,
    y2: 21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChallenge);
export default __webpack_public_path__ + "static/media/noChallenge.48059348befcd4b42671c647ef8d50a1.svg";
export { ForwardRef as ReactComponent };